import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMe } from '@/lib/useMe';

/**
 * Gates every authenticated route on GET /api/admin-auth/me. Three states:
 *   - pending: render nothing yet (avoids a login-page flash for an admin who
 *     already has a valid session cookie);
 *   - resolved to null (401 / no session): redirect to /login;
 *   - resolved to an AdminMe: render the authenticated subtree.
 * A network/5xx error is NOT treated as "no session" — that would bounce a
 * signed-in admin to /login on a transient api-py blip. It renders nothing
 * and stays on the current URL; useMe has no retry, so a real outage shows an
 * empty shell rather than a login-redirect loop.
 */
export function RequireSession() {
  const location = useLocation();
  const { data, isPending, isError } = useMe();

  if (isPending || isError) return null;
  if (data === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
